export const catchError = (err: unknown) => {
  console.error(err);
};
